import React, { ReactElement } from 'react';

import { TSkipToContentProperties } from './skip-to-content.types';
import { StyledLink } from './skip-to-content.styled';

export function SkipToContent({
    text,
    href,
}: TSkipToContentProperties): ReactElement {
    return <StyledLink href={href}>{text}</StyledLink>;
}
